export const environment = {
  production: true,
  environmentName: 'Staging',

  apiVersion: '0.1',

  dadataToken: '619372db49fcf624bf7ff019bdb24cba873d609f',
  dadataApiUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs',

  domainCookie: '',

  apiUrl: 'https://api.ra.cloudworkshop.ru',
  clientId: 'RA.Web.PromoPages',
  clientSecret: 'FeUrI0X5j6HDOx1zQTHZHwxmR10c3RbA',
};
